import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'manage-services.pricing-action-required.title',
    defaultMessage: 'Action required',
  },
  subtitle: {
    id: 'manage-services.pricing-action-required.subtitle',
    defaultMessage:
      'One or more of your pricing submissions could not be verified. Open the affected service to review and resubmit.',
  },
});
